// import * as THREE from "three";
// import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';
// import { Scene, PerspectiveCamera, WebGLRenderer } from "three";
// import { ElementController } from "./element_controller";

window.THREE = THREE;
var THREE = require("three");

const Custom3DViewerPlugin = (editor, options) => {
  if (editor) {
    editor.Blocks.add("3d_viewer_v2", {
      label: "3D Viewer V2",
      category: "3D Simulation",
      select: true,
      media: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16"><path d="M8 0l8 4v8l-8 4-8-4V4l8-4zm0 1.2L1.6 4v7.8L8 14.8l6.4-3V4L8 1.2zM7 5h2v6H7V5z"/></svg>`,
      content: {
        type: "3d_viewer_v2",
      },
    });

    // const viewerScript = function (props) {
    //   console.log('@props', props);

    //   const container = this;
    //   let THREE, STLLoader;
    //   let URDFLoader;

    //   async function init3DViewer() {
    //     try {
    //         if (typeof THREE === "undefined") {
    //             const threeScript = document.createElement("script");
    //             threeScript.src = "https://cdnjs.cloudflare.com/ajax/libs/three.js/0.156.1/three.min.js"; // UMD Version
    //             // threeScript.src = "https://unpkg.com/three@0.128.0/build/three.min.js";
    //             threeScript.onload = () => {
    //                 THREE = window.THREE;
    //                 loadSTLLoader();
    //                 loadURDFLoader();  // Ensure URDFLoader is loaded

    //                 console.log('@1');
    //             };
    //             document.head.appendChild(threeScript);

    //             console.log('@2');
    //         } else {
    //             loadSTLLoader();
    //             loadURDFLoader();  // Ensure URDFLoader is loaded

    //             console.log('@3');
    //         }
    //     } catch (error) {
    //         handleError(error);

    //         console.log('@4');
    //     }
    //   }

    //   const loadURDFModel = (scene, url, position, scale, loader) => {
    //     console.log(`Loading URDF model from ${url}...`); // Debugging log
    //     loader.load(
    //       url,
    //       (robot) => {
    //         console.log(`Loaded URDF model: ${url}`); // Debugging log
    //         robot.position.copy(position);
    //         robot.scale.set(scale, scale, scale);
    //         scene.add(robot);
    //       },
    //       (progress) => {
    //         console.log(`URDF Loading Progress: ${progress.loaded} / ${progress.total}`);
    //       },
    //       (error) => {
    //         console.error("Error loading URDF model:", error);
    //       }
    //     );
    //   };

    //   function loadSTLLoader() {
    //     const loaderScript = document.createElement("script");
    //     loaderScript.src = "https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/loaders/STLLoader.js"; // Updated
    //     loaderScript.onload = () => {
    //         STLLoader = new THREE.STLLoader();
    //         setupViewer();
    //         console.log('@5');
    //     };
    //     loaderScript.onerror = () => {
    //         console.error("Failed to load STLLoader.js. Check the URL or try another source.");
    //     };
    //     document.head.appendChild(loaderScript);
    //     console.log('@6');
    //   }

    //   function loadURDFLoader() {
    //     const urdfScript = document.createElement("script");
    //     urdfScript.src = "https://cdn.jsdelivr.net/npm/urdf-loader@0.12.4/umd/URDFLoader.js"; // Updated
    //     urdfScript.onload = () => {
    //         if (window.URDFLoader) {
    //             URDFLoader = window.URDFLoader;
    //         } else {
    //             console.error("URDFLoader failed to load.");
    //         }
    //         setupViewer();
    //         console.log('@7');
    //     };
    //     urdfScript.onerror = () => {
    //         console.error("Failed to load urdf-loader.min.js. Check the URL or try another source.");
    //     };
    //     document.head.appendChild(urdfScript);
    //     console.log('@8');
    //   }

    //   function setupViewer() {
    //     if (!STLLoader || !URDFLoader) {
    //       console.error("STLLoader or URDFLoader is not loaded yet!");
    //       return;
    //     }

    //     console.log('@9');

    //     let viewerCanvas = document.createElement("canvas");
    //     viewerCanvas.className = "3d-viewer-canvas";
    //     viewerCanvas.style.width = "100%";
    //     viewerCanvas.style.height = "100%";
    //     viewerCanvas.style.display = "block";
    //     container.appendChild(viewerCanvas);

    //     const scene = new THREE.Scene();
    //     const camera = new THREE.PerspectiveCamera(
    //       75,
    //       container.clientWidth / container.clientHeight,
    //       0.1,
    //       1000
    //     );

    //     const renderer = new THREE.WebGLRenderer({
    //       canvas: viewerCanvas,
    //       antialias: true,
    //     });
    //     renderer.setSize(container.clientWidth, container.clientHeight);
    //     renderer.setPixelRatio(window.devicePixelRatio);

    //     camera.position.set(0, 5, 10);
    //     camera.lookAt(0, 0, 0);

    //     // Lighting
    //     const light = new THREE.AmbientLight(0xffffff, 1);
    //     scene.add(light);
    //     const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
    //     directionalLight.position.set(5, 10, 5);
    //     scene.add(directionalLight);

    //     // Load STL Model function
    //     const loadSTLModel = (url, color, position, scale) => {
    //       console.log(`Loading STL model from ${url}...`); // Debugging log
    //       return new Promise((resolve, reject) => {
    //         STLLoader.load(
    //           url,
    //           (geometry) => {
    //             console.log(`Loaded STL model: ${url}`); // Debugging log
    //             const material = new THREE.MeshStandardMaterial({
    //               color,
    //               metalness: 0.5,
    //               roughness: 0.7,
    //             });
    //             const mesh = new THREE.Mesh(geometry, material);
    //             mesh.position.copy(position);
    //             mesh.scale.set(scale, scale, scale);
    //             scene.add(mesh);
    //             resolve(mesh);
    //           },
    //           undefined,
    //           (error) => {
    //             console.error(`Error loading STL model from ${url}`, error);
    //             reject(error);
    //           }
    //         );
    //       });
    //     };

    //     if (props.urdfUrl) {
    //       const loadingManager = new THREE.LoadingManager();
    //       const urdfLoader = new URDFLoader(loadingManager);

    //       urdfLoader.loadMeshCb = (path, manager, onComplete) => {
    //           const loader = new STLLoader(manager);
    //           loader.load(path, (geometry) => {
    //               const material = new THREE.MeshPhongMaterial();
    //               const mesh = new THREE.Mesh(geometry, material);
    //               onComplete(mesh);
    //           });
    //       };

    //       loadURDFModel(scene, props.urdfUrl, new THREE.Vector3(2, 0, 0), 1, urdfLoader);
    //     }

    //     // Load models if URLs are provided
    //     if (props.environmentUrl) {
    //       console.log('@props.environmentUrl', props.environmentUrl);
    //       loadSTLModel(
    //         props.environmentUrl,
    //         0xffffff,
    //         new THREE.Vector3(-5, 0, 0),
    //         1
    //       );
    //     }

    //     if (props.binUrl) {
    //       loadSTLModel(
    //         props.binUrl,
    //         0x00ff00,
    //         new THREE.Vector3(4, 0, 0),
    //         2
    //       );
    //     }

    //     if (props.sensorURL) {
    //       loadSTLModel(
    //         props.sensorURL,
    //         0x0000ff,
    //         new THREE.Vector3(4, 0, 3),
    //         2
    //       );
    //     }

    //     function animate() {
    //       requestAnimationFrame(animate);
    //       renderer.render(scene, camera);
    //     }

    //     animate();

    //     // Handle window resize
    //     const handleResize = () => {
    //       camera.aspect = container.clientWidth / container.clientHeight;
    //       camera.updateProjectionMatrix();
    //       renderer.setSize(container.clientWidth, container.clientHeight);
    //     };

    //     window.addEventListener("resize", handleResize);

    //     // Cleanup function
    //     container.cleanup = () => {
    //       window.removeEventListener("resize", handleResize);
    //       renderer.dispose();
    //     };
    //   }

    //   function handleError(error) {
    //     console.error("Failed to initialize 3D viewer:", error);
    //     const errorDiv = document.createElement("div");
    //     errorDiv.style.color = "red";
    //     errorDiv.textContent = `Failed to initialize 3D viewer: ${error.message}`;
    //     container.appendChild(errorDiv);
    //   }

    //   init3DViewer();
    // };

    const viewerScript = function (props) {
      const container = this;
      container.style.position = "relative";

      // function loadScript(src, callback) {
      //     const script = document.createElement("script");
      //     script.src = src;
      //     script.onload = callback;
      //     script.onerror = () => console.error(`Failed to load script: ${src}`);
      //     document.head.appendChild(script);
      // }

      // this function first checks if the cdn has been already loaded or not. Only loads the cdn if not already loaded
      function loadScript(src, callback) {
        // Check if the script is already loaded
        if (document.querySelector(`script[src="${src}"]`)) {
          console.log(`Script already loaded: ${src}`);
          callback(); // Proceed with the callback if the script is already loaded
          return;
        }

        // If the script is not loaded, create a new script element
        const script = document.createElement("script");
        script.src = src;
        script.onload = callback;
        script.onerror = () => console.error(`Failed to load script: ${src}`);

        // Append the script element to the document head
        document.head.appendChild(script);
      }

      // Load Three.js and URDFLoader in the correct order
      loadScript(
        "https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js",
        () => {
          loadScript(
            "https://cdn.jsdelivr.net/npm/three@0.128/examples/js/loaders/STLLoader.js",
            () => {
              loadScript(
                "https://cdn.jsdelivr.net/npm/urdf-loader@0.12.4/umd/URDFLoader.js",
                () => {
                  loadScript(
                    "https://cdn.jsdelivr.net/npm/three@0.128/examples/js/controls/OrbitControls.js",
                    () => {
                      loadScript(
                        "https://cdn.jsdelivr.net/npm/three@0.128/examples/js/loaders/ColladaLoader.js",
                        () => {
                          console.log("collada-loader loaded");
                          initializeViewer();
                        }
                      );
                    }
                  );
                }
              );
            }
          );
        }
      );

      function initializeViewer() {
        console.log("props", props);
        // console.log("Three.js and loaders loaded");

        if (typeof THREE === "undefined") {
          console.error("THREE is still not defined!");
          return;
        }

        // console.log("THREE.Object3D:", THREE.Object3D);
        // console.log("THREE.Object3D.DEFAULT_UP:", THREE.Object3D?.DEFAULT_UP);
        // console.log("THREE.OrbitControls:", THREE.OrbitControls);

        // Attempting to set DEFAULT_UP
        // THREE.Object3D.DEFAULT_UP.set(0, 0, 1);

        const viewerCanvas = document.createElement("canvas");
        viewerCanvas.className = "3d-viewer-canvas";
        viewerCanvas.style.width = "100%";
        viewerCanvas.style.height = "100%";
        viewerCanvas.style.display = "block";
        viewerCanvas.style.pointerEvents = "auto";

        container.appendChild(viewerCanvas);

        // console.log("Viewer canvas added to:", viewerCanvas.parentElement);
        // console.log("viewer pointerEvents:", getComputedStyle(viewerCanvas).pointerEvents);

        const scene = new THREE.Scene();

        if (THREE.Object3D.DefaultUp) {
          THREE.Object3D.DefaultUp.set(0, 0, 1);
          console.log("DefaultUp is available");
        } else {
          console.warn(
            "DefaultUp is not available in this version of THREE. Using manual up setting."
          );
          scene.up.set(0, 0, 1);
        }

        // Set up an orthographic camera
        let aspect = window.innerWidth / window.innerHeight;
        let viewSize = Number(props.viewVerticalSize); // Desired vertical size of the view

        // Calculate initial camera parameters
        let left = (-aspect * viewSize) / 2;
        let right = (aspect * viewSize) / 2;
        let top = viewSize / 2;
        let bottom = -viewSize / 2;

        // Set up the camera
        // const camera = new THREE.PerspectiveCamera(
        //     75,
        //     container.clientWidth / container.clientHeight,
        //     0.1,
        //     1000
        // );
        const camera = new THREE.OrthographicCamera(
          left,
          right,
          top,
          bottom,
          0.01,
          5000
        );
        camera.position.set(
          Number(props.cameraXPosition),
          Number(props.cameraYPosition),
          Number(props.cameraZPosition)
        );
        camera.lookAt(
          Number(props.cameraLookAtX),
          Number(props.cameraLookAtY),
          Number(props.cameraLookAtZ)
        );
        camera.updateProjectionMatrix(); // Always update the projection matrix after changing near/far values

        // Create a separate HUD scene to fix the axes helper in one position
        const hudScene = new THREE.Scene();
        const hudCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0.1, 10);
        hudCamera.position.z = 2; // Adjust based on helper size
        hudScene.add(hudCamera);

        // Clone axesHelper for HUD
        const hudAxesHelper = new THREE.AxesHelper(1.5);
        hudScene.add(hudAxesHelper);

        // Create a separate renderer for HUD
        const hudRenderer = new THREE.WebGLRenderer({ alpha: true });
        hudRenderer.setSize(100, 100); // Small fixed size for axes
        hudRenderer.domElement.style.position = "absolute";
        hudRenderer.domElement.style.bottom =
          `${Number(props.axesHelperYAxis)}` + "%"; // 5% from bottom of container
        hudRenderer.domElement.style.left =
          `${Number(props.axesHelperXAxis)}` + "%"; // 5% from left of container
        // hudRenderer.domElement.style.width = "12%";  // Adjusted to fit inside canvas
        // hudRenderer.domElement.style.height = "12%"; // Maintain aspect ratio
        hudRenderer.domElement.style.pointerEvents = "none";

        container.appendChild(hudRenderer.domElement);

        // Create a WebGL renderer
        const renderer = new THREE.WebGLRenderer({
          canvas: viewerCanvas,
          antialias: true,
          alpha: true,
          preserveDrawingBuffer: true, // Prevent depth issues when moving objects
          logarithmicDepthBuffer: true, // Improves rendering precision at all distances
        });
        renderer.autoClear = true;
        renderer.sortObjects = true;
        renderer.setSize(container.clientWidth, container.clientHeight);
        renderer.setClearColor(0xffffff);
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        renderer.setPixelRatio(window.devicePixelRatio);
        container.appendChild(renderer.domElement);

        // // Use scene bounding calculations to position axis helper always at the bottom left of the scene
        // let bbox = new THREE.Box3();
        // scene.traverse((child) => {
        //     if (child.isMesh && child.geometry) {
        //         child.geometry.computeBoundingBox();  // Ensure bounding box is computed
        //         const childBbox = new THREE.Box3().setFromObject(child);
        //         bbox.union(childBbox); // Expand bbox to include this mesh
        //     }
        // });

        // // If bounding box is still empty, force a fallback
        // if (bbox.isEmpty()) {
        //     console.warn("Bounding box is empty. Ensure objects exist and have geometry.");
        // } else {
        //     console.log("Bounding box min:", bbox.min, "max:", bbox.max);
        // }

        // const min = bbox.min;
        // console.log("Corrected min:", min);

        // const axesHelper = new THREE.AxesHelper(Number(props.axesHelperSize));
        // axesHelper.position.set(Number(props.axesHelperXAxis), Number(props.axesHelperYAxis), Number(props.axesHelperZAxis)); // Adjust based on scene scale
        // // Use scene bounding calculations to position axis helper always at the bottom left of the scene
        // // axesHelper.position.set(min.x, min.y, min.z); // Adjust as needed
        // scene.add( axesHelper );

        // Lighting
        const light = new THREE.AmbientLight(0xffffff, 1);
        scene.add(light);
        const directionalLight = new THREE.DirectionalLight(0xfdb913, 0.8);
        directionalLight.position.set(5, 5, 5);
        directionalLight.castShadow = true; // Enable shadows for the light
        directionalLight.shadow.bias = -0.0001; // Reduces shadow acne
        directionalLight.shadow.mapSize.width = 2048;
        directionalLight.shadow.mapSize.height = 2048;
        scene.add(directionalLight);

        const controls = new THREE.OrbitControls(camera, viewerCanvas);
        controls.enableDamping = true; // Smooth movement
        controls.dampingFactor = 0.1;
        controls.screenSpacePanning = true;
        controls.minDistance = 1; // Min zoom
        controls.maxDistance = 100; // Max zoom
        controls.enablePan = true;

        controls.mouseButtons = {
          LEFT: THREE.MOUSE.PAN, // Pan with left-click
          RIGHT: THREE.MOUSE.ROTATE, // Rotate with right-click
          MIDDLE: THREE.MOUSE.DOLLY,
        };

        // Enhance Camera Movement
        controls.dampingFactor = 0.2; // Smooth camera damping
        controls.rotateSpeed = 0.8; // Slow down rotation speed
        controls.zoomSpeed = 0.5; // Adjust zoom speed
        controls.panSpeed = 0.5; // Improve panning experience

        // Auto-adjust camera near/far planes
        function adjustCameraBounds() {
          let boundingBox = new THREE.Box3().setFromObject(scene);
          let size = boundingBox.getSize(new THREE.Vector3());
          camera.near = Math.max(0.1, size.length() * 0.01);
          camera.far = Math.max(1000, size.length() * 10);
          camera.updateProjectionMatrix();
        }

        // Call after loading all objects
        setTimeout(adjustCameraBounds, 1000);

        // Optional: Manually handle the keydown for ArrowUp and ArrowDown to control panning
        viewerCanvas.addEventListener("keydown", (event) => {
          if (event.key === "ArrowUp") {
            controls.pan(0, 0.1); // Adjust as needed for up panning
          } else if (event.key === "ArrowDown") {
            controls.pan(0, -0.1); // Adjust as needed for down panning
          }
        });

        controls.update();

        // controls.addEventListener("start", () => console.log("OrbitControls started"));
        // controls.addEventListener("end", () => console.log("OrbitControls ended"));

        // Robot management
        let selectedAxis = null;
        let robots = [];
        let activeRobot = null;
        let isDragging = false;
        let isRotating = false;
        let prevMousePos = { x: 0, z: 0 };
        const rotationSpeed = 0.05;
        const raycaster = new THREE.Raycaster();
        const mouse = new THREE.Vector2();

        // // // // // Handle mouse move
        // // // // function onMouseMove(event) {
        // // // //   // console.log('mm', event);
        // // // //   mouse.x = (event.clientX / viewerCanvas.clientWidth) * 2 - 1;
        // // // //   mouse.y = -(event.clientY / viewerCanvas.clientHeight) * 2 + 1;

        // // // //   if ((isDragging || isRotating) && activeRobot) {
        // // // //       raycaster.setFromCamera(mouse, camera);
        // // // //       const plane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
        // // // //       const intersect = raycaster.ray.intersectPlane(plane, new THREE.Vector3());
        // // // //       if (intersect) {
        // // // //           if (isDragging) {
        // // // //               activeRobot.position.set(intersect.x, activeRobot.position.y, intersect.z);
        // // // //           } else if (isRotating) {
        // // // //               const deltaX = event.clientX - prevMousePos.x;
        // // // //               const deltaZ = event.clientY - prevMousePos.z;
        // // // //               activeRobot.rotation.z += deltaX * rotationSpeed;
        // // // //               activeRobot.rotation.x += deltaZ * rotationSpeed;
        // // // //               prevMousePos.x = event.clientX;
        // // // //               prevMousePos.z = event.clientY;
        // // // //           }
        // // // //       }
        // // // //   }
        // // // // }

        // // // function onMouseMove(event) {
        // // //   if (!isRotating || !activeRobot || !selectedAxis) return;

        // // //   const deltaX = (event.clientX - prevMousePos.x) * 0.01;
        // // //   const deltaZ = (event.clientY - prevMousePos.z) * 0.01;

        // // //   let axisVector = new THREE.Vector3();

        // // //   if (selectedAxis === 'x') axisVector.set(1, 0, 0);
        // // //   if (selectedAxis === 'y') axisVector.set(0, 1, 0);
        // // //   if (selectedAxis === 'z') axisVector.set(0, 0, 1);

        // // //   // Apply rotation to the local object group, not the scene
        // // //   axisVector.applyQuaternion(activeRobot.quaternion);
        // // //   let quaternion = new THREE.Quaternion();
        // // //   quaternion.setFromAxisAngle(axisVector, deltaX + deltaZ);
        // // //   activeRobot.applyQuaternion(quaternion);

        // // //   prevMousePos.x = event.clientX;
        // // //   prevMousePos.z = event.clientY;
        // // // }

        // // function onMouseMove(event) {
        // //   if (!isRotating || !activeRobot || !selectedAxis) return;

        // //   const deltaX = (event.clientX - prevMousePos.x) * 0.01;
        // //   const deltaY = (event.clientY - prevMousePos.y) * 0.01;

        // //   let axisVector = new THREE.Vector3();

        // //   if (selectedAxis === 'x') axisVector.set(1, 0, 0);
        // //   if (selectedAxis === 'y') axisVector.set(0, 1, 0);
        // //   if (selectedAxis === 'z') axisVector.set(0, 0, 1);

        // //   // Apply rotation only to the activeRobot (not the whole scene)
        // //   const quaternion = new THREE.Quaternion();
        // //   quaternion.setFromAxisAngle(axisVector, deltaX + deltaY);
        // //   activeRobot.quaternion.premultiply(quaternion); // Ensure rotation is applied locally

        // //   prevMousePos.x = event.clientX;
        // //   prevMousePos.y = event.clientY;
        // // }

        // function onMouseMove(event) {
        //   if (isRotating && activeRobot && selectedAxis) {
        //       const deltaX = (event.clientX - prevMousePos.x) * 0.01;
        //       const deltaY = (event.clientY - prevMousePos.y) * 0.01;

        //       let axisVector = new THREE.Vector3();
        //       if (selectedAxis === 'x') axisVector.set(1, 0, 0);
        //       if (selectedAxis === 'y') axisVector.set(0, 1, 0);
        //       if (selectedAxis === 'z') axisVector.set(0, 0, 1);

        //       const quaternion = new THREE.Quaternion();
        //       quaternion.setFromAxisAngle(axisVector, deltaX + deltaY);
        //       activeRobot.quaternion.multiplyQuaternions(quaternion, activeRobot.quaternion);

        //       prevMousePos.x = event.clientX;
        //       prevMousePos.y = event.clientY;
        //   }

        //   if (isDragging && activeRobot) {
        //       const deltaX = (event.clientX - prevMousePos.x) * 0.01;
        //       const deltaZ = (event.clientY - prevMousePos.y) * 0.01;

        //       // Move along XZ plane
        //       activeRobot.position.x += deltaX;
        //       activeRobot.position.z += deltaZ;

        //       prevMousePos.x = event.clientX;
        //       prevMousePos.y = event.clientY;
        //   }
        // }

        let lastMouseX = 0,
          lastMouseY = 0; // Prevent excessive calls

        // function onMouseMove(event) {
        //     if (!activeRobot) return; // Ensure an object is selected

        //     // Prevent unnecessary updates
        //     if (Math.abs(event.clientX - lastMouseX) < 1 && Math.abs(event.clientY - lastMouseY) < 1) return;
        //     lastMouseX = event.clientX;
        //     lastMouseY = event.clientY;

        //     const deltaX = (event.clientX - prevMousePos.x) * 0.01;
        //     const deltaY = (event.clientY - prevMousePos.y) * 0.01;

        //     if (isRotating) {
        //         // Apply rotation only to the active object
        //         let axisVector = new THREE.Vector3();

        //         if (selectedAxis === 'x') axisVector.set(1, 0, 0);
        //         if (selectedAxis === 'y') axisVector.set(0, 1, 0);
        //         if (selectedAxis === 'z') axisVector.set(0, 0, 1);

        //         // Apply rotation to the selected object
        //         const quaternion = new THREE.Quaternion();
        //         quaternion.setFromAxisAngle(axisVector, deltaX + deltaY);
        //         activeRobot.quaternion.multiplyQuaternions(quaternion, activeRobot.quaternion);
        //     }

        //     if (isDragging) {
        //         // Apply transformation (movement) only to the selected object
        //         activeRobot.position.x += deltaX;
        //         activeRobot.position.z += deltaY;
        //     }

        //     prevMousePos.x = event.clientX;
        //     prevMousePos.y = event.clientY;
        // }

        function onMouseMove(event) {
          if (!activeRobot) return;

          const deltaX = (event.clientX - prevMousePos.x) * 0.01;
          const deltaY = (event.clientY - prevMousePos.y) * 0.01;

          if (isDragging) {
            // Fix flipped movement by inverting the axis updates
            activeRobot.position.x += deltaX;
            activeRobot.position.z -= deltaY;
          }

          if (isRotating) {
            // Rotate around local axes
            activeRobot.rotateOnWorldAxis(new THREE.Vector3(0, 1, 0), deltaX); // Y-axis rotation
            activeRobot.rotateOnAxis(new THREE.Vector3(1, 0, 0), -deltaY); // X-axis rotation
          }

          if (activeRobot) {
            activeRobot.traverse((node) => {
              if (node.isMesh) {
                node.geometry.computeBoundingBox();
                node.geometry.computeBoundingSphere();
              }
            });
          }

          prevMousePos.x = event.clientX;
          prevMousePos.y = event.clientY;
        }

        // // // // // Handle mouse down
        // // // // // function onMouseDown(event) {
        // // // // //     // console.log('md', event);
        // // // // //     raycaster.setFromCamera(mouse, camera);
        // // // // //     const intersects = raycaster.intersectObjects(robots, true);
        // // // // //     if (intersects.length > 0) {
        // // // // //         let clickedObject = intersects[0].object;
        // // // // //         while (clickedObject.parent && !robots.includes(clickedObject)) {
        // // // // //             clickedObject = clickedObject.parent;
        // // // // //         }
        // // // // //         activeRobot = clickedObject;

        // // // // //         if (event.button === 0) {
        // // // // //             isDragging = true;
        // // // // //         } else if (event.button === 2) {
        // // // // //             prevMousePos.x = event.clientX;
        // // // // //             prevMousePos.z = event.clientY;
        // // // // //             isRotating = true;
        // // // // //         }
        // // // // //     }
        // // // // // }

        // // // // function onMouseDown(event) {
        // // // //   const mouse = new THREE.Vector2();
        // // // //   mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
        // // // //   mouse.y = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1;

        // // // //   raycaster.setFromCamera(mouse, camera);
        // // // //   const intersects = raycaster.intersectObjects(scene.children, true);

        // // // //   if (intersects.length > 0) {
        // // // //       let clickedObject = intersects[0].object;
        // // // //       console.log('Clicked Object:', clickedObject);

        // // // //       // Find the parent group of the clicked object
        // // // //       while (clickedObject.parent && !robots.includes(clickedObject)) {
        // // // //           clickedObject = clickedObject.parent;
        // // // //       }

        // // // //       activeRobot = clickedObject;
        // // // //       console.log("Selected Object (Group):", activeRobot);

        // // // //       // Hide rotation wheels for all objects before showing for the selected one
        // // // //       robots.forEach(obj => {
        // // // //           if (obj.userData.wheels) {
        // // // //               Object.values(obj.userData.wheels).forEach(wheel => wheel.visible = false);
        // // // //           }
        // // // //       });

        // // // //       // Show rotation wheels for the selected object group
        // // // //       if (activeRobot.userData.wheels) {
        // // // //           Object.values(activeRobot.userData.wheels).forEach(wheel => wheel.visible = true);
        // // // //       }

        // // // //       // Detect if rotation should be applied
        // // // //       if (clickedObject.userData.axis) {
        // // // //           selectedAxis = clickedObject.userData.axis;
        // // // //           isRotating = true;
        // // // //           prevMousePos.x = event.clientX;
        // // // //           prevMousePos.z = event.clientY;
        // // // //       } else {
        // // // //           isDragging = true;
        // // // //       }
        // // // //   }
        // // // // }

        // // // function onMouseDown(event) {
        // // //   const mouse = new THREE.Vector2();
        // // //   mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
        // // //   mouse.y = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1;

        // // //   raycaster.setFromCamera(mouse, camera);
        // // //   const intersects = raycaster.intersectObjects(scene.children, true);

        // // //   if (intersects.length > 0) {
        // // //       let clickedObject = intersects[0].object;
        // // //       console.log('Clicked Object:', clickedObject);

        // // //       // Find the parent group of the clicked object
        // // //       while (clickedObject.parent && !robots.includes(clickedObject)) {
        // // //           clickedObject = clickedObject.parent;
        // // //       }

        // // //       activeRobot = clickedObject;
        // // //       console.log("Selected Object (Group):", activeRobot);

        // // //       // Hide rotation wheels for all objects before showing for the selected one
        // // //       robots.forEach(obj => {
        // // //           if (obj.userData.wheels) {
        // // //               Object.values(obj.userData.wheels).forEach(wheel => wheel.visible = false);
        // // //           }
        // // //       });

        // // //       // Show rotation wheels for the selected object group
        // // //       if (activeRobot.userData.wheels) {
        // // //           Object.values(activeRobot.userData.wheels).forEach(wheel => wheel.visible = true);
        // // //       }

        // // //       // Detect if rotation should be applied
        // // //       if (clickedObject.userData.axis) {
        // // //           selectedAxis = clickedObject.userData.axis;
        // // //           isRotating = true;
        // // //           prevMousePos.x = event.clientX;
        // // //           prevMousePos.y = event.clientY;
        // // //       }
        // // //   }
        // // // }

        // // function onMouseDown(event) {
        // //   const mouse = new THREE.Vector2();
        // //   mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
        // //   mouse.y = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1;

        // //   raycaster.setFromCamera(mouse, camera);
        // //   const intersects = raycaster.intersectObjects(scene.children, true);

        // //   if (intersects.length > 0) {
        // //       let clickedObject = intersects[0].object;
        // //       console.log('Clicked Object:', clickedObject);

        // //       // Ensure selection is applied to the full object group
        // //       while (clickedObject.parent && !robots.includes(clickedObject)) {
        // //           clickedObject = clickedObject.parent;
        // //       }

        // //       activeRobot = clickedObject;
        // //       console.log("Selected Object (Group):", activeRobot);

        // //       // Hide all rotation wheels before showing for the selected one
        // //       robots.forEach(obj => {
        // //           if (obj.userData.wheels) {
        // //               Object.values(obj.userData.wheels).forEach(wheel => wheel.visible = false);
        // //           }
        // //       });

        // //       // Show rotation wheels for the selected object
        // //       if (activeRobot.userData.wheels) {
        // //           Object.values(activeRobot.userData.wheels).forEach(wheel => wheel.visible = true);
        // //       }

        // //       // Detect if rotation or movement should be applied
        // //       if (clickedObject.userData.axis) {
        // //           selectedAxis = clickedObject.userData.axis;
        // //           isRotating = true;
        // //           prevMousePos.x = event.clientX;
        // //           prevMousePos.y = event.clientY;
        // //       } else {
        // //           isDragging = true; // Enable movement instead of rotation
        // //       }

        // //       // Prevent scene from moving if an object is selected
        // //       controls.enabled = false;
        // //   } else {
        // //       activeRobot = null; // Reset selection
        // //       controls.enabled = true; // Enable scene rotation
        // //   }
        // // }

        // function onMouseDown(event) {
        //   const mouse = new THREE.Vector2();
        //   mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
        //   mouse.y = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1;

        //   raycaster.setFromCamera(mouse, camera);
        //   const intersects = raycaster.intersectObjects(scene.children, true);

        //   if (intersects.length > 0) {
        //       let clickedObject = intersects[0].object;

        //       while (clickedObject.parent && !robots.includes(clickedObject)) {
        //           clickedObject = clickedObject.parent;
        //       }

        //       activeRobot = clickedObject;
        //       console.log("Selected Object:", activeRobot);

        //       // Hide rotation wheels for all objects before showing for the selected one
        //       robots.forEach(obj => {
        //           if (obj.userData.wheels) {
        //               Object.values(obj.userData.wheels).forEach(wheel => wheel.visible = false);
        //           }
        //       });

        //       // Show rotation wheels for the selected object
        //       if (activeRobot.userData.wheels) {
        //           Object.values(activeRobot.userData.wheels).forEach(wheel => wheel.visible = true);
        //       }

        //       if (event.button === 2) { // Right click for rotation
        //           isRotating = true;
        //           prevMousePos.x = event.clientX;
        //           prevMousePos.y = event.clientY;
        //       } else if (event.button === 0) { // Left click for movement
        //           isDragging = true;
        //           prevMousePos.x = event.clientX;
        //           prevMousePos.y = event.clientY;
        //       }

        //       controls.enabled = false; // Disable scene rotation when interacting with an object
        //   } else {
        //       activeRobot = null;
        //       controls.enabled = true; // Enable scene rotation if no object is selected
        //   }
        // }

        function onMouseDown(event) {
          const mouse = new THREE.Vector2();
          mouse.x = (event.clientX / renderer.domElement.clientWidth) * 2 - 1;
          mouse.y = -(event.clientY / renderer.domElement.clientHeight) * 2 + 1;

          raycaster.setFromCamera(mouse, camera);
          const intersects = raycaster.intersectObjects(scene.children, true);

          if (intersects.length > 0) {
            let clickedObject = intersects[0].object;

            while (clickedObject.parent && !robots.includes(clickedObject)) {
              clickedObject = clickedObject.parent;
            }

            activeRobot = clickedObject;
            console.log("Selected Object:", activeRobot);

            // Show rotation wheels for the selected object
            if (activeRobot.userData.wheels) {
              Object.values(activeRobot.userData.wheels).forEach(
                (wheel) => (wheel.visible = true)
              );
            }

            if (event.button === 2) {
              // Right-click for rotation
              isRotating = true;
              prevMousePos.x = event.clientX;
              prevMousePos.y = event.clientY;
            } else if (event.button === 0) {
              // Left-click for movement
              isDragging = true;
              prevMousePos.x = event.clientX;
              prevMousePos.y = event.clientY;
            }

            controls.enabled = false; // Disable scene rotation when interacting with an object
          } else {
            activeRobot = null;
            controls.enabled = true; // Enable scene rotation if no object is selected
          }
        }

        // // // Handle mouse up
        // // function onMouseUp() {
        // //     // console.log('mu');
        // //     isDragging = false;
        // //     isRotating = false;
        // // }

        // function onMouseUp() {
        //   isRotating = false;
        //   selectedAxis = null;

        //   // Hide rotation wheels after rotation stops
        //   if (activeRobot && activeRobot.userData.wheels) {
        //       Object.values(activeRobot.userData.wheels).forEach(wheel => wheel.visible = false);
        //   }
        // }

        function onMouseUp() {
          isRotating = false;
          isDragging = false;
          selectedAxis = null;

          if (!activeRobot) {
            controls.enabled = true; // Enable scene rotation if no object is selected
          }

          // Hide rotation wheels after interaction stops
          if (activeRobot && activeRobot.userData.wheels) {
            Object.values(activeRobot.userData.wheels).forEach(
              (wheel) => (wheel.visible = false)
            );
          }
        }

        // Handle mouse wheel zoom
        function onMouseWheel(event) {
          // console.log('mw', event);
          const zoomSpeed = 0.05;
          camera.zoom += event.deltaY > 0 ? zoomSpeed : -zoomSpeed;
          camera.zoom = Math.max(0.1, Math.min(5, camera.zoom));
          camera.updateProjectionMatrix();
        }

        // Handle window resize
        function onWindowResize() {
          let newAspect = viewerCanvas.clientWidth / viewerCanvas.clientHeight;
          let newLeft = (-newAspect * viewSize) / 2;
          let newRight = (newAspect * viewSize) / 2;
          let newTop = viewSize / 2;
          let newBottom = -viewSize / 2;

          camera.left = newLeft;
          camera.right = newRight;
          camera.top = newTop;
          camera.bottom = newBottom;
          camera.updateProjectionMatrix();
          renderer.setSize(viewerCanvas.clientWidth, viewerCanvas.clientHeight);
        }

        // Create Local Axes Helper for Translation
        function createAxisCylinder(axis, radius, length, color) {
          const geometry = new THREE.CylinderGeometry(
            radius,
            radius,
            length,
            8
          );
          const material = new THREE.MeshBasicMaterial({ color });
          const axisObject = new THREE.Mesh(geometry, material);

          if (axis === "x") axisObject.rotation.set(0, 0, Math.PI / 2);
          if (axis === "y") axisObject.rotation.set(0, Math.PI / 2, 0);
          if (axis === "z") axisObject.rotation.set(Math.PI / 2, 0, 0);

          axisObject.userData.axis = axis;
          return axisObject;
        }

        function createLocalAxesHelper(radius, length) {
          const group = new THREE.Group();
          const xAxis = createAxisCylinder("x", radius, length, 0xff0000);
          const yAxis = createAxisCylinder("y", radius, length, 0x00ff00);
          const zAxis = createAxisCylinder("z", radius, length, 0x0000ff);

          group.add(xAxis, yAxis, zAxis);
          group.userData.cylinders = { x: xAxis, y: yAxis, z: zAxis };

          // Initially hidden, only show when object is selected
          xAxis.visible = yAxis.visible = zAxis.visible = false;

          return group;
        }

        // Create Rotation Wheels for Rotation Control
        function createRotationRing(axis, color, radius) {
          const geometry = new THREE.TorusGeometry(radius, 0.05, 16, 100); // Slightly thicker for better interaction
          const material = new THREE.MeshBasicMaterial({
            color,
            transparent: true,
            opacity: 0.8,
          });

          const ring = new THREE.Mesh(geometry, material);
          ring.userData.axis = axis;

          if (axis === "x") ring.rotation.set(0, Math.PI / 2, 0);
          if (axis === "y") ring.rotation.set(Math.PI / 2, 0, 0);
          if (axis === "z") ring.rotation.set(0, 0, 0);

          ring.renderOrder = 2; // Ensure it's rendered on top of objects
          return ring;
        }

        function createRotationWheels(radius) {
          const group = new THREE.Group();
          const xRing = createRotationRing("x", 0xff0000, radius);
          const yRing = createRotationRing("y", 0x00ff00, radius);
          const zRing = createRotationRing("z", 0x0000ff, radius);

          group.add(xRing, yRing, zRing);
          group.userData.wheels = { x: xRing, y: yRing, z: zRing };

          // Initially hidden, only show when object is selected
          xRing.visible = yRing.visible = zRing.visible = false;

          return group;
        }

        // Attach Axes & Rotation Controls to Loaded Objects
        function attachManipulationControls(object) {
          if (!object) return;

          const localAxesHelper = createLocalAxesHelper(0.05, 1.5); // Adjust size as needed
          const rotationWheels = createRotationWheels(1.2); // Adjust size as needed

          object.add(localAxesHelper);
          object.add(rotationWheels);

          object.userData.cylinders = localAxesHelper.userData.cylinders;
          object.userData.wheels = rotationWheels.userData.wheels;

          // Ensure wheels are initially hidden
          Object.values(object.userData.wheels).forEach(
            (wheel) => (wheel.visible = false)
          );
        }

        // // Load STL Model function
        // const loadSTLModel = (url, color, position, scale, rotation) => {
        //     return new Promise((resolve, reject) => {
        //         const loader = new THREE.STLLoader();
        //         // console.log('@loader', loader);
        //         loader.load(
        //             url,
        //             (geometry) => {
        //                 const material = new THREE.MeshStandardMaterial({
        //                     color,
        //                     metalness: 0.5,
        //                     roughness: 0.7,
        //                     side: THREE.DoubleSide,  // This will render both sides of the mesh
        //                 });
        //                 const mesh = new THREE.Mesh(geometry, material);
        //                 // mesh.position.copy(position);
        //                 mesh.castShadow = true;
        //                 mesh.receiveShadow = true;
        //                 mesh.scale.set(scale, scale, scale);
        //                 // Apply the rotation here using the Euler object
        //                 // mesh.rotation.copy(rotation);
        //                 // Enable shadow for meshes
        //                 robots.push(mesh); // Add to selectable objects
        //                 scene.add(mesh); // Add to the scene
        //                 resolve(mesh);
        //             },
        //             undefined,
        //             (error) => {
        //                 console.error(`Error loading STL model from ${url}`, error);
        //                 reject(error);
        //             }
        //         );
        //     });
        // };

        // // Load URDF Model function
        // const loadURDFModel = (scene, url, position, scale, rotation) => {
        //     if (typeof window.URDFLoader === "undefined") {
        //         console.error("URDFLoader is not defined!");
        //         return;
        //     }

        //     const loader = new window.URDFLoader();
        //     // Create an AxesHelper for the local coordinate system
        //     // const localAxesHelper = new THREE.AxesHelper(2); // Size of the axes
        //     loader.load(url, (robot) => {
        //         console.log('URDF Loaded:', robot);

        //         robot.traverse((node) => {
        //           if (node.isMesh) {
        //               node.castShadow = true;
        //               node.receiveShadow = true;
        //           }
        //         });
        //         // Apply the position
        //         robot.position.copy(position);
        //         // Apply the rotation
        //         robot.rotation.copy(rotation);
        //         // robot.add(localAxesHelper); // Attach the localAxesHelper to the robot
        //         robot.scale.set(scale, scale, scale);
        //         robots.push(robot); // Add group instead of direct robot
        //         scene.add(robot);
        //     }, undefined, (error) => {
        //       console.error('Error loading URDF:', error);
        //     });
        // };

        // Load STL Model function
        const loadSTLModel = (url, color, position, scale, rotation) => {
          return new Promise((resolve, reject) => {
            const loader = new THREE.STLLoader();
            loader.load(
              url,
              (geometry) => {
                const material = new THREE.MeshStandardMaterial({
                  color,
                  metalness: 0.5,
                  roughness: 0.7,
                  side: THREE.DoubleSide,
                });
                const mesh = new THREE.Mesh(geometry, material);
                mesh.frustumCulled = false; // Ensures the object is always rendered
                mesh.geometry.computeBoundingSphere(); // Ensures bounding volume updates properly
                mesh.castShadow = true;
                mesh.receiveShadow = true;

                // Create a group to manage transformation separately
                const objectGroup = new THREE.Group();
                objectGroup.position.copy(position);
                objectGroup.scale.set(scale, scale, scale);
                objectGroup.rotation.copy(rotation);
                objectGroup.add(mesh);

                attachManipulationControls(objectGroup); // Ensure controls attach to the group
                robots.push(objectGroup);
                scene.add(objectGroup);
                resolve(objectGroup);
              },
              undefined,
              (error) => {
                console.error(`Error loading STL model from ${url}`, error);
                reject(error);
              }
            );
          });
        };

        // Load URDF Model function
        const loadURDFModel = (scene, url, position, scale, rotation) => {
          if (typeof window.URDFLoader === "undefined") {
            console.error("URDFLoader is not defined!");
            return;
          }

          const loader = new window.URDFLoader();
          loader.load(
            url,
            (robot) => {
              robot.traverse((node) => {
                if (node.isMesh) {
                  node.castShadow = true;
                  node.receiveShadow = true;
                  node.frustumCulled = false; // Prevents disappearing on certain camera angles
                  node.geometry.computeBoundingSphere();
                }
              });

              // Wrap the robot inside a group
              const objectGroup = new THREE.Group();
              objectGroup.position.copy(position);
              objectGroup.scale.set(scale, scale, scale);
              objectGroup.rotation.copy(rotation);
              objectGroup.add(robot);

              attachManipulationControls(objectGroup);
              robots.push(objectGroup);
              scene.add(objectGroup);
            },
            undefined,
            (error) => {
              console.error("Error loading URDF:", error);
            }
          );
        };

        // Load URDF if provided
        if (props.urdfUrl) {
          loadURDFModel(
            scene,
            props.urdfUrl,
            new THREE.Vector3(
              Number(props.urdfPosX),
              Number(props.urdfPosY),
              Number(props.urdfPosZ)
            ),
            Number(props.urdfScale),
            new THREE.Euler(
              (Number(props.urdfRotX) * Math.PI) / 180,
              (Number(props.urdfRotY) * Math.PI) / 180,
              (Number(props.urdfRotZ) * Math.PI) / 180
            )
          );
        }
        // Load STL models if URLs are provided
        if (props.environmentUrl) {
          const rotation = new THREE.Euler(
            (Number(props.envRotX) * Math.PI) / 180,
            (Number(props.envRotY) * Math.PI) / 180,
            (Number(props.envRotZ) * Math.PI) / 180
          );
          loadSTLModel(
            props.environmentUrl,
            0xffffff, // Color
            new THREE.Vector3(
              Number(props.envPosX),
              Number(props.envPosY),
              Number(props.envPosZ)
            ),
            Number(props.envScale),
            new THREE.Euler(
              (Number(props.envRotX) * Math.PI) / 180,
              (Number(props.envRotY) * Math.PI) / 180,
              (Number(props.envRotZ) * Math.PI) / 180
            )
          );
        }
        if (props.binUrl) {
          const rotation = new THREE.Euler(
            (Number(props.binRotX) * Math.PI) / 180,
            (Number(props.binRotY) * Math.PI) / 180,
            (Number(props.binRotZ) * Math.PI) / 180
          );
          loadSTLModel(
            props.binUrl,
            0x00ff00, // Color
            new THREE.Vector3(
              Number(props.binPosX),
              Number(props.binPosY),
              Number(props.binPosZ)
            ),
            Number(props.binScale),
            new THREE.Euler(
              (Number(props.binRotX) * Math.PI) / 180,
              (Number(props.binRotY) * Math.PI) / 180,
              (Number(props.binRotZ) * Math.PI) / 180
            )
          );
        }
        if (props.sensorURL) {
          const rotation = new THREE.Euler(
            (Number(props.sensorRotX) * Math.PI) / 180,
            (Number(props.sensorRotY) * Math.PI) / 180,
            (Number(props.sensorRotZ) * Math.PI) / 180
          );
          loadSTLModel(
            props.sensorURL,
            0x0000ff, // Color
            new THREE.Vector3(
              Number(props.sensorPosX),
              Number(props.sensorPosY),
              Number(props.sensorPosZ)
            ),
            Number(props.sensorScale),
            new THREE.Euler(
              (Number(props.sensorRotX) * Math.PI) / 180,
              (Number(props.sensorRotY) * Math.PI) / 180,
              (Number(props.sensorRotZ) * Math.PI) / 180
            )
          );
        }

        // Attach event listeners to `viewerCanvas`
        viewerCanvas.addEventListener("pointerdown", onMouseDown);
        viewerCanvas.addEventListener("mousemove", onMouseMove);
        viewerCanvas.addEventListener("pointerup", onMouseUp);
        viewerCanvas.addEventListener("wheel", onMouseWheel);
        window.addEventListener("resize", onWindowResize);

        // Render function
        const animate = () => {
          requestAnimationFrame(animate);
          controls.update();
          renderer.render(scene, camera);

          // to fix the axesHelper in one place
          // Update HUD axes to match world rotation
          hudAxesHelper.quaternion.copy(camera.quaternion);

          // Render the HUD scene
          hudRenderer.render(hudScene, hudCamera);
        };
        animate();
      }
    };

    editor.TraitManager.addType("fileupload", {
      createInput({ trait }) {
        // wrapper
        const wrap = document.createElement("div");
        wrap.style.display = "flex";
        wrap.style.alignItems = "center";

        // text input
        const input = document.createElement("input");
        input.type = "text";
        input.style.flex = "1";
        input.value = trait.get("value") || "";
        wrap.appendChild(input);

        // keep text input in sync if the trait changes elsewhere
        trait.on("change:value", (_, v) => {
          input.value = v;
        });

        // upload button
        const btn = document.createElement("button");
        btn.type = "button";
        btn.innerText = "Upload";
        btn.style.marginLeft = "4px";
        wrap.appendChild(btn);

        // hidden file input
        const fileIn = document.createElement("input");
        fileIn.type = "file";
        fileIn.style.display = "none";
        wrap.appendChild(fileIn);

        // click “Upload” → open file picker
        btn.addEventListener("click", () => fileIn.click());

        fileIn.addEventListener("change", async () => {
          if (!fileIn.files?.length) return;
          const file = fileIn.files[0];
          const form = new FormData();
          form.append("file", file);

          // if you use JWT auth:
          const raw = localStorage.getItem("userInfo");
          console.log("raw", raw);
          const token = raw ? JSON.parse(raw).token : null;
          console.log("token", token);

          const res = await fetch(
            `https://backend1.redsling.com/3d-upload/upload`,
            {
              method: "POST",
              headers: token ? { Authorization: "Bearer " + token } : undefined,
              body: form,
            }
          );
          if (!res.ok) {
            return alert("Upload failed");
          }
          const { url } = await res.json();
          // set both the DOM input and the trait value
          input.value = url;
          trait.set("value", url);
        });

        return wrap;
      },
    });

    editor.DomComponents.addType("3d_viewer_v2", {
      model: {
        defaults: {
          tagName: "div",
          script: viewerScript,
          type: "3d_viewer_v2",

          urdfUrl: "",
          environmentUrl: "",
          binUrl: "",
          sensorURL: "",

          viewVerticalSize: 20,

          axesHelperSize: 1.5,
          axesHelperXAxis: -17,
          axesHelperYAxis: -7,
          axesHelperZAxis: 0,

          cameraXPosition: 0,
          cameraYPosition: 0,
          cameraZPosition: 0,

          cameraLookAtX: 0,
          cameraLookAtY: 0,
          cameraLookAtZ: 0,

          urdfScale: 3,
          urdfPosX: -2,
          urdfPosY: 0,
          urdfPosZ: 0,

          envScale: 3,
          envPosX: -5,
          envPosY: 0,
          envPosZ: 0,

          binScale: 3,
          binPosX: 4,
          binPosY: 0,
          binPosZ: 0,

          sensorScale: 3,
          sensorPosX: 4,
          sensorPosY: 0,
          sensorPosZ: 3,

          // New Rotation Traits
          urdfRotX: 0,
          urdfRotY: 0,
          urdfRotZ: 0,
          envRotX: 0,
          envRotY: 0,
          envRotZ: 0,
          binRotX: 0,
          binRotY: 0,
          binRotZ: 0,
          sensorRotX: 0,
          sensorRotY: 0,
          sensorRotZ: 0,

          traits: [
            {
              type: "fileupload",
              name: "urdfUrl",
              label: "URDF URL",
              changeProp: true,
            },
            {
              type: "fileupload",
              name: "environmentUrl",
              label: "Environment URL",
              changeProp: true,
            },
            {
              type: "fileupload",
              name: "binUrl",
              label: "Bin URL",
              changeProp: true,
            },
            {
              type: "fileupload",
              name: "sensorURL",
              label: "Sensor URL",
              changeProp: true,
            },
            {
              type: "text",
              name: "urdfUrl",
              label: "URDF URL",
              placeholder: "Enter URDF URL",
              changeProp: true,
            },
            {
              type: "text",
              name: "environmentUrl",
              label: "Environment URL",
              placeholder: "Enter 3D model URL",
              changeProp: true,
            },
            {
              type: "text",
              name: "binUrl",
              label: "Bin URL",
              placeholder: "Enter Bin URL",
              changeProp: true,
            },
            {
              type: "text",
              name: "sensorURL",
              label: "Sensor URL",
              placeholder: "Enter Sensor URL",
              changeProp: true,
            },

            {
              type: "number",
              name: "viewVerticalSize",
              label: "View's Vertical Size",
              placeholder: "20",
              min: 1,
              changeProp: true,
            },

            // { type: "number", name: "axesHelperSize", label: "Axes Helper Size", placeholder: "3", min: 1, changeProp: true },
            {
              type: "number",
              name: "axesHelperXAxis",
              label: "Axes Helper XAxis POS",
              placeholder: "3",
              changeProp: true,
            },
            {
              type: "number",
              name: "axesHelperYAxis",
              label: "Axes Helper YAxis POS",
              placeholder: "5",
              changeProp: true,
            },
            // { type: "number", name: "axesHelperZAxis", label: "Axes Helper ZAxis POS", placeholder: "0", changeProp: true },

            {
              type: "number",
              name: "cameraXPosition",
              label: "Camera X Position",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "cameraYPosition",
              label: "Camera Y Position",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "cameraZPosition",
              label: "Camera Z Position",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "cameraLookAtX",
              label: "Camera LookAt X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "cameraLookAtY",
              label: "Camera LookAt Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "cameraLookAtZ",
              label: "Camera LookAt Z",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "urdfScale",
              label: "Urdf Scale",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "urdfPosX",
              label: "Urdf Pos X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "urdfPosY",
              label: "Urdf Pos Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "urdfPosZ",
              label: "Urdf Pos Z",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "envScale",
              label: "Env Scale",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "envPosX",
              label: "Env Pos X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "envPosY",
              label: "Env Pos Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "envPosZ",
              label: "Env Pos Z",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "binScale",
              label: "Bin Scale",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "binPosX",
              label: "Bin Pos X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "binPosY",
              label: "Bin Pos Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "binPosZ",
              label: "Bin Pos Z",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "sensorScale",
              label: "Sensor Scale",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "sensorPosX",
              label: "Sensor Pos X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "sensorPosY",
              label: "Sensor Pos Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "sensorPosZ",
              label: "Sensor Pos Z",
              placeholder: "0",
              changeProp: true,
            },

            // New Rotation Traits
            {
              type: "number",
              name: "urdfRotX",
              label: "URDF Rotation X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "urdfRotY",
              label: "URDF Rotation Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "urdfRotZ",
              label: "URDF Rotation Z",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "envRotX",
              label: "Environment Rotation X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "envRotY",
              label: "Environment Rotation Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "envRotZ",
              label: "Environment Rotation Z",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "binRotX",
              label: "Bin Rotation X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "binRotY",
              label: "Bin Rotation Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "binRotZ",
              label: "Bin Rotation Z",
              placeholder: "0",
              changeProp: true,
            },

            {
              type: "number",
              name: "sensorRotX",
              label: "Sensor Rotation X",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "sensorRotY",
              label: "Sensor Rotation Y",
              placeholder: "0",
              changeProp: true,
            },
            {
              type: "number",
              name: "sensorRotZ",
              label: "Sensor Rotation Z",
              placeholder: "0",
              changeProp: true,
            },
          ],

          "script-props": [
            "urdfUrl",
            "environmentUrl",
            "binUrl",
            "sensorURL",
            "viewVerticalSize",
            "axesHelperSize",
            "axesHelperXAxis",
            "axesHelperYAxis",
            "axesHelperZAxis",
            "cameraXPosition",
            "cameraYPosition",
            "cameraZPosition",
            "cameraLookAtX",
            "cameraLookAtY",
            "cameraLookAtZ",
            "urdfScale",
            "urdfPosX",
            "urdfPosY",
            "urdfPosZ",
            "envScale",
            "envPosX",
            "envPosY",
            "envPosZ",
            "binScale",
            "binPosX",
            "binPosY",
            "binPosZ",
            "sensorScale",
            "sensorPosX",
            "sensorPosY",
            "sensorPosZ",
            "urdfRotX",
            "urdfRotY",
            "urdfRotZ",
            "envRotX",
            "envRotY",
            "envRotZ",
            "binRotX",
            "binRotY",
            "binRotZ",
            "sensorRotX",
            "sensorRotY",
            "sensorRotZ",
          ],
          changeProp: true,

          attributes: { class: "3d_viewer_v2_container" },

          style: {
            width: "100%",
            height: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // background: "#eaeaea",
          },

          "style-default": {
            width: "100%",
            height: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // background: "#eaeaea",
          },
        },
      },
    });
  }
};

export default Custom3DViewerPlugin;
